import { motion } from "motion/react";
import { t } from "@/lib/i18n";
import type { SkillsSection as SkillsData } from "@/data/profile";
import type { SectionProps } from "../types";
import { SectionFrame } from "../SectionFrame";

export function SkillsSection({ section, number, ctx }: SectionProps<SkillsData>) {
  const { lang, presets } = ctx;

  return (
    <SectionFrame number={number} kicker={section.kicker} title={section.title} ctx={ctx}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, maxWidth: 560 }}>
        {section.skills.map((skill, i) => (
          <motion.div
            key={t(skill, lang)}
            variants={presets.pop(0.12 + i * 0.05)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "9px 15px",
              background: "var(--tc-paper)",
              border: "1px solid var(--tc-line)",
              borderRadius: 4,
            }}
          >
            <span style={{ width: 6, height: 6, background: "var(--tc-brass)", transform: "rotate(45deg)", flex: "none" }} />
            <span style={{ fontSize: 15, color: "var(--tc-text)", whiteSpace: "nowrap" }}>{t(skill, lang)}</span>
          </motion.div>
        ))}
      </div>
    </SectionFrame>
  );
}
